module.exports = __webpack_public_path__ + "img/8.c4e9d89a.png";